// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const helperSlice = createSlice({
  name: 'userHelper',
  initialState: {},
  reducers: {
    handleUserHelper: (state, action) => {
      state.userHelper = action.payload

    }
  }
})

export const { handleUserHelper } = helperSlice.actions

export default helperSlice.reducer
